<template>
  <div id="end-Page">
    <div class="endCardBox">
      <div class="endCardBoxInner">
        <div class="dotL"></div>
        <div class="dotR"></div>
        <p
          class="title"
          :style="{'text-align':this.textCenter?'center':'left'}"
          v-html="title"
        ></p>
        <p
          class="tips"
          v-html="tips"
        ></p>
        <div
          class="nextBtn"
          v-if="outPath"
          @click="nextQues"
        >
          下一份问卷
        </div>
      </div>
    </div>
    <p
      class="footTips"
      v-html="footTips"
    >
    </p>
  </div>
</template>

<script>
import { GetQueryString } from '../../utils/utils'

export default {
  data() {
    return {
      outPath: '',
      title: '答题结束，谢谢您的参与！',
      tips:
        '请注意：酬金将在审核后发放，请注意留意<br>公众号发送的通知，及时领取。',
      footTips:
        '您还可以将本问卷转发给您的朋友，<br>请点击右上角...处转发给好友或分享到朋友圈。',
      isAnswerFlog: false,
      textCenter: false,
    }
  },
  methods: {
    // 获取下一份问卷
    async getQuesList() {
      let type = window.sessionStorage.getItem('queType')
      let params = {
        type: type,
      }
      let url = await $api.getNextQuestionnaireUrl(params)
      if (url) {
        this.outPath = url
      }
    },
    // 进入下一份问卷
    nextQues() {
      window.top.location.href = `${
        process.env.VUE_APP_BaseURL
      }/questionnaire?outPath=${encodeURIComponent(this.outPath)}`
    },
  },
  created() {
    this.isAnswerFlog = this.$route.query.isAnswer ? true : false
    let status = GetQueryString('status') + ''
    if (this.isAnswerFlog) {
      this.title = '很抱歉,您已经答过此问卷了！'
      this.tips = ''
      this.footTips = ''
      this.textCenter = true
    } else if (status !== '1') {
      this.title = '不好意思，您不太适合本次调查<br>谢谢您的参与！'
      this.tips = ''
      this.footTips = ''
      this.textCenter = true
    }
    this.getQuesList()
  },
}
</script>
<style lang='less'>
#end-Page {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 44px 23px 0;
  overflow: auto;
  background: url('../../assets/images/bg.png');
  .endCardBox {
    position: relative;
    width: 100%;
    height: 165px;
    background-color: #f56b6b;
    border-bottom-left-radius: 40px;
    border-bottom-right-radius: 40px;
    .endCardBoxInner {
      position: absolute;
      width: 100%;
      height: 165px;
      top: -1px;
      left: 0;
      right: 0;
      background-color: @colorDefault;
      border-bottom-left-radius: 40px;
      border-bottom-right-radius: 40px;
      padding: 30px 35px 0;
      box-sizing: border-box;
      color: #fff;
      .dotL {
        width: 10px;
        height: 10px;
        border-radius: 10px;
        position: absolute;
        top: 15px;
        left: 20px;
        background-color: #fff;
      }
      .dotR {
        width: 10px;
        height: 10px;
        border-radius: 10px;
        position: absolute;
        top: 15px;
        right: 20px;
        background-color: #fff;
      }
      .title {
        font-size: 13px;
        line-height: 24px;
        font-weight: bold;
      }
      .tips {
        font-size: 10.5px;
        line-height: 18px;
      }
      .nextBtn {
        width: 116px;
        height: 30px;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: -15px;
        font-size: 14px;
        text-align: center;
        line-height: 30px;
        color: #fff;
        background-color: #f56b6b;
        border-radius: 15px;
        // .van-button {
        //   height: 100%;
        //   width: 100%;
        //   line-height: 1;
        //   padding: 0;
        //   .van-button__text {
        //     font-size: 14px;
        //   }
        // }
      }
    }
  }
  .footTips {
    margin-top: 30px;
    font-size: 10.5px;
    line-height: 18px;
    text-align: center;
    color: #474747;
  }
}
</style>
